<template>
  <div class="carousel-wrapper">
    <div
      class="carousel"
      :style="{ height }"
    >
      <v-img
        v-for="(image, i) in images"
        :key="`carousel-photo-${i}`"
        class="carousel__photo"
        :class="{
          active: active === i,
          prev: active !== i && active === (i + 1) % images.length,
          next: active !== i && (active + 1) % images.length === i
        }"
        :height="height"
        :src="image"
      />

      <div
        v-if="controls"
        class="carousel__button--next"
        @click="next"
      />
      <div
        v-if="controls"
        class="carousel__button--prev"
        @click="prev"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    controls: {
      type: Boolean,
      default: false
    },
    duration: {
      type: Number,
      default: 5000
    },
    images: {
      type: Array,
      default: () => []
    },
    height: {
      type: String,
      default: '250px'
    }
  },
  data () {
    return {
      interval: null,
      active: 0
    }
  },
  watch: {
    images () {
      this.start()
    }
  },
  mounted () {
    this.start()
  },
  beforeDestroy () {
    this.stop()
  },
  methods: {
    start () {
      this.stop()
      this.active = 0

      if (this.images.length > 1) {
        this.interval = setInterval(this.next, this.duration)
      }
    },
    stop () {
      if (this.interval) {
        clearInterval(this.interval)
      }
    },
    next () {
      this.active = (this.active + 1) % this.images.length
    },
    prev () {
      this.active = (this.active - 1) % this.images.length
    }
  }
}
</script>

<style lang="scss">
.carousel-wrapper {
  overflow: hidden;
  background: #d3d3d3;
}

.carousel {
  transform-style: preserve-3d;

  &__photo {
    opacity: 0;
    position: absolute;
    top:0;
    // width: 100%;
    // margin: auto;
    // padding: 1rem 4rem;
    z-index: 100;
    transition: transform .5s, opacity .5s, z-index .5s;

    &.initial,
    &.active {
      opacity: 1;
      position: relative;
      z-index: 900;
    }

    &.prev,
    &.next {
      z-index: 800;
    }

    &.prev {
      transform: translateX(-100%); /* Move 'prev' item to the left */
    }

    &.next {
      transform: translateX(100%); /* Move 'next' item to the right */
    }
  }

  .carousel__button--prev,
  .carousel__button--next {
    position: absolute;
    top:50%;
    width: 3rem;
    height: 3rem;
    background-color: #FFF;
    transform: translateY(-50%);
    border-radius: 50%;
    cursor: pointer;
    z-index: 1001; /* Sit on top of everything */
    border: 1px solid black;
  }

  .carousel__button--prev {
    left:0;
  }

  .carousel__button--next {
    right:0;
  }

  .carousel__button--prev::after,
  .carousel__button--next::after {
    content: " ";
    position: absolute;
    width: 10px;
    height: 10px;
    top: 50%;
    left: 54%;
    border-right: 2px solid black;
    border-bottom: 2px solid black;
    transform: translate(-50%, -50%) rotate(135deg);
  }

  .carousel__button--next::after {
    left: 47%;
    transform: translate(-50%, -50%) rotate(-45deg);
  }
}
</style>
